/* eslint-disable @typescript-eslint/typedef */
/**
 * @desc Filter key constants for ethical hacking filter operations.
 * These keys match the backend {@link FilterKeys} enum and are used in {@link FilterSearchCriteria}.
 *
 * **IMPORTANT**: These values must exactly match the backend FilterKeys enum values.
 *
 * @see Backend: src/_common/constants/filter-keys-constants.ts
 * @see {@link FilterSearchCriteria}
 */
export const EthicalHackingFilterKeys = {
  // Core vulnerability filters
  /** Filter by vulnerability/finding status (open, closed, etc.) */
  FINDING_STATUS: 'FINDING_STATUS',

  /** Filter to include/exclude treated items */
  CONTAINS_TREATED: 'CONTAINS_TREATED',

  /** Filter by specific finding/vulnerability ID */
  FINDING_ID: 'FINDING_ID',

  /** Filter by perimeter (free text) */
  PERIMETER: 'PERIMETER',

  /** Filter by vulnerability title (free text) */
  VULNERABILITY_TITLE: 'VULNERABILITY_TITLE',

  /** Filter by remediation (free text) */
  REMEDIATION: 'REMEDIATION',

  /** Filter by severity level (critical, high, medium, low, info) */
  SEVERITY: 'SEVERITY',

  /** Filter by priority level */
  PRIORITY: 'PRIORITY',

  /** Filter by owner (free text) */
  OWNER: 'OWNER',

  /** Filter by client status (unresolved, corrected, accepted_risk, retest_pending, resolved) */
  CLIENT_STATUS: 'CLIENT_STATUS',

  /** Filter by target name/host */
  TARGET_NAME: 'TARGET_NAME',

  // Assessment filters
  /** Filter by assessment status (completed, in_progress, etc.) */
  ASSESSMENT_STATUS: 'ASSESSMENT_STATUS',

  /** Filter by assessment title (free text) */
  ASSESSMENT_TITLE: 'ASSESSMENT_TITLE',

  /** Filter by assessment severity */
  ASSESSMENT_SEVERITY: 'ASSESSMENT_SEVERITY',

  // Date filters
  /** Filter by creation date (before specified date) */
  CREATED_AT_BEFORE: 'CREATED_AT_BEFORE',

  /** Filter by period (date range) */
  PERIOD: 'PERIOD',

  // Special filters
  /** Generic include filter */
  INCLUDES: 'INCLUDES',

  /** Filter vulnerabilities by category (all, open, treated, closed, assigned, unassigned) - Frontend specific */
  FILTER_VULNERABILITIES_BY: 'filterVulnerabilitiesBy'
} as const;
